module.exports = __webpack_public_path__ + "assets/img/home_banner1_bg.421c6b79.png";